// 备注，情报的组件不支持配置话，所以第一期只支持组件的显示隐藏
export const PAGE_CONFIG = {
  name: 'PcCompetitor',
};